var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 32,
    viewBox: "0 0 43 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.2279 0.229492H5.77148V31.7708H37.2279V0.229492Z",
    fill: "#F1F5F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 19.3168L37.2278 31.7706V7.18408L21.5 19.3168Z",
    fill: "#DCE6EA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5388 0.229492H37.2282L21.5004 12.6832L5.7718 0.229492H4.46126C2.29098 0.229492 0.529297 1.99557 0.529297 4.17209V27.828C0.529297 30.0041 2.29098 31.7707 4.46126 31.7707H5.7718V7.18419L21.5004 19.3143L37.2282 7.18129V31.7707H38.5388C40.7096 31.7707 42.4712 30.004 42.4712 27.828V4.17218C42.4713 1.99565 40.7097 0.229492 38.5388 0.229492Z",
    fill: "#FF9500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.bd7e56062df294f1ec6c6045fe12d0c7.svg";
export { ForwardRef as ReactComponent };